const sessionIdDefault = "GENERATE_NEW_SESSION_ID"

export default {
  sessionIdDefault: sessionIdDefault,
  currentSessionId: sessionIdDefault,
  convoItems: [],
  sessionHistory: {},
  isFetchingSessionHistory: false
};
